export enum HolidayTime {
	StartOfDay = 0,
	MidDay = 10,
	EndOfDay = 20
}